
<div class="row mt-4">
    <div class="col-md-12">
       <h5 class="capt common-bene-class-for-translation"> Settings</h5>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
       <p class="capt-desc common-bene-class-for-translation">View and Manage your account settings</p> 
    </div>
</div>


<div *ngIf="userTypeRole === 'Beneficiary' || 'Petitioner' || 'Attorney';else  nodata"> <!---temp. if clause to block other  users-->
<div class=" settings-page-content  row">
    <div class="col-md-12">
      <div class="bg-white py-3">
      <div class="nav-menu">
       <ul>
          <li *ngFor="let item of settings_menu;let idx=index;">
            <a  [ngClass]="{ active: activeMainmenu === item['main-title-key']}"  *ngIf="item['disabled']; else enabled"  href="javascript:void(0)"
            disabled (click)="fetchSubmenuitems(idx)" >
              <label class="common-bene-class-for-translation">{{ item['main-title'] }}</label>
            </a>
            <ng-template #enabled>
              <a   [ngClass]="{active: activeMainmenu === item['main-title-key'] }"  (click)="fetchSubmenuitems(idx)" >
                <label class="common-bene-class-for-translation">{{item['main-title'] }}</label>
              </a>
            </ng-template>
          </li>
          <li *ngIf="userTypeRole == 'Beneficiary'">
            <a   [ngClass]="{active: activeMainmenu === 'changeLanguage' }"  (click)="loadComponent('changeLanguage'); activeMainmenu = 'changeLanguage'" >
              <label class="common-bene-class-for-translation">Change Language</label>
            </a>
          </li>
        </ul>
      </div> 
    </div>
      <mat-drawer-container class="settings-mat-container">
          <mat-drawer class="settings-landing" mode="side" opened>
              <!-- <div class="vertical-menu">
                  <a  *ngFor="let item of settings_sub_menu;let subindex" 
                    (click)="loadComponent(item.key)" class="pointer active">
                      {{item.name}}
                  </a> 
                </div>--->
                
          </mat-drawer>
          <mat-drawer-content>
            <ng-container #componentholder></ng-container>
          </mat-drawer-content>
      </mat-drawer-container>
  </div>
</div>
</div> <!---temp. if clause to block other  users-->
<ng-template #nodata>
   <p class="text-center nodata"><strong class="common-bene-class-for-translation">No Data</strong><p>
</ng-template>
